var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"setting"},[_c('van-cell',{attrs:{"title":"修改绑定手机号","is-link":"","to":"/vascularNews/user/bindNew","size":"large"}}),_vm._v(" "),_c('div',{staticClass:"exitBtn",on:{"click":_vm.logoutLogin}},[_vm._v("\n\t\t退出登录\n\t")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8277645c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/VascularSystem/Personal/Setting.vue
// module id = null
// module chunks = 